/* © CNES */
import { useContext, useMemo } from 'react';
import Floater from 'react-floater';
import { filterSections } from '../../../../../../assets/config/filters/Referenciel';
import { ConfigContext } from '../../../../../../context/ConfigContext';
import { FilterDataContext } from '../../../../../../context/FilterDataContext';
import { CustomCalendar } from '../../../../../shared/Calendar/CustomCalendar';
import {
  END_DATE_TIME,
  START_DATE_TIME,
} from '../../../../../shared/Constants';
import {
  StartGuidContent,
  startGuidStyle,
} from '../../../../../shared/startGuidContent/StartGuidContent';
import './InnerWhen.scss';

/**
 * InnerWhen Displays calendars to select dates for filter.
 * @param onChangeDate Function to bubble dates when changed.
 * @returns InnerWhen Element.
 */
export const InnerWhen = ({
  onChangeDate,
}: {
  onChangeDate: (e: Date, key: string) => void;
}) => {
  const { filterData } = useContext(FilterDataContext);
  const context = useContext(ConfigContext);
  /**
   * onChange handle date change in calendar.
   * @param value the date value selected.
   * @param key the calendar key from which the date is selected from.
   */
  const onChange = (value: Date, key: string) => {
    onChangeDate(value, key);
  };

  const endDate = useMemo(() => {
    let date: Date | null = null;
    if (
      filterData[END_DATE_TIME] &&
      !Array.isArray(filterData[END_DATE_TIME])
    ) {
      date = new Date(filterData[END_DATE_TIME].slice(0, -1));
    }
    return date;
  }, [filterData]);

  const startDate = useMemo(() => {
    let date: Date | null = null;
    if (
      filterData[START_DATE_TIME] &&
      !Array.isArray(filterData[START_DATE_TIME])
    ) {
      date = new Date(filterData[START_DATE_TIME].slice(0, -1));
    }
    return date;
  }, [filterData]);

  return (
    <div className="formgrid grid mt-2">
      <Floater
        open={context.isGetStarted}
        content={
          <StartGuidContent
            title="Pick a date"
            body="Select a start date and an end date to limit the scope of your search"
            icon="calendar.png"
          />
        }
        placement="auto-end"
        styles={{ ...startGuidStyle }}
        target=".formgrid"
      />
      <div className="field col">
        <span className="startDate">Start Date</span>
        <CustomCalendar
          onChange={onChange}
          name={filterSections.endDate.param}
          dateValue={endDate}
        />
      </div>
      <div className="field col">
        <span className="endDate">End Date</span>
        <CustomCalendar
          onChange={onChange}
          name={filterSections.startDate.param}
          dateValue={startDate}
        />
      </div>
    </div>
  );
};
